const moment = require('moment');

export default {
  methods: {
    updateDate(startDate, endDate) {
      this.startDate = moment(startDate).format('MM/DD/YYYY');

      this.endDate = moment(endDate).format('MM/DD/YYYY');

      const selectedInterval = this.selected(this.startDate, this.endDate);

      if (selectedInterval.title === 'Last 30 Days') {
        this.$router.push({name: this.$route.name}).catch(() => {
        });
      } else {
        this.$router.push({
          name: this.$route.name,
          query: {
            'start-date': moment(startDate).format('MM-DD-YYYY'),
            'end-date': moment(endDate).format('MM-DD-YYYY'),
          },
        }).catch(() => {
        });
      }
      this.updatePage();

    },
    drawChart(dates, customs, rounds, monthly) {

      let maxY = null;
      if (
        customs.reduce((a, b) => a + b, 0) === 0 &&
        monthly.reduce((a, b) => a + b, 0) === 0 &&
        rounds.reduce((a, b) => a + b, 0) === 0
      ) {
        maxY = 10;
      }

      //zero value corners fix
      customs = customs.map(v => v > 0 ? v : -1);
      rounds = rounds.map(v => v > 0 ? v : -1);
      monthly = monthly.map(v => v > 0 ? v : -1);

// eslint-disable-next-line
      const chart = Highcharts.chart('graph', {
        chart: {
          type: 'column',
        },
        title: false,
        xAxis: {
          categories: dates,
          labels: {
            style: {
              color: '#050926',
              fontFamily: 'var(--main-font-family)',
              opacity: '0.5',
              fontSize: '12px',
              paddingTop: '10px',
            },
          },
          minorTickLength: 0,
          tickLength: 0,
          offset: 10,
          lineColor: 'transparent',
        },
        yAxis: {
          max: maxY,
          min: 0,
          title: false,
          labels: {
            formatter: function () {
              return '$' + this.axis.defaultLabelFormatter.call(this);
            },
            style: {
              color: '#050926',
              fontFamily: 'var(--main-font-family)',
              opacity: '0.5',
              fontSize: '12px',
            },
          },
        },
        legend: false,
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat: '{series.name}: ${point.y}<br/>Total: ${point.stackTotal}',
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false,
// eslint-disable-next-line
              color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white',
            },
            borderWidth: 0,
          },
        },
        colors: [
          '#fab42d',
          '#1ecc9a',
          '#0d70e3',
        ],
        series: [
          {
            name: 'One-Time',
            data: customs,
            borderRadiusTopLeft: 4,
            borderRadiusTopRight: 4,
          },
          {
            name: 'Monthly',
            data: monthly,
            borderRadiusTopLeft: 4,
            borderRadiusTopRight: 4,
          },
          {
            name: 'Round-Ups',
            data: rounds,
            borderRadiusTopLeft: 4,
            borderRadiusTopRight: 4,
          },
        ],
      });
      setTimeout(() => {
        try {
          chart.redraw();
        }
// eslint-disable-next-line
        catch (e) {
        }
      }, 500);

    },
  },
  computed: {
    period() {
      return {
        start: moment(this.startDate, 'MM/DD/YYYY'),
        end: moment(this.endDate, 'MM/DD/YYYY').set({
          'hour': 23,
          'minute': 59,
          'second': 59,
        }),
      };
    },
    donationsData() {
      const startUnix = this.period.start.unix();
      const endUnix = this.period.end.unix();

      const res = this.donations
        .filter(item => startUnix < item.createdAtParsed && item.createdAtParsed <= endUnix)
        .map(item => {

          item['fees'] = parseFloat(item.stripe_fee);
          item['net_total'] = item.amount - item['fees'];

          return item;
        });
      return JSON.parse(JSON.stringify(res));
    },
    summary: function () {
      let summary = {
        rounds: 0,
        custom: 0,
        monthly: 0,
        fees: 0,
        platform_fee: 0,
        stripe_fee: 0,
        total_amounts: 0,
        fees_covered: 0,
      };

      for (let donation of this.donationsData) {
        summary.platform_fee += donation.platform_fee * 1;
        summary.stripe_fee += donation.stripe_fee * 1 - donation.platform_fee * 1;

        switch (donation.type) {
          case 'custom':
            summary.custom += donation.amount * 1;
            break;
          case 'roundup':
            summary.rounds += donation.amount * 1;
            break;
          case 'recurring':
            summary.monthly += donation.amount * 1;
            break;
        }

        summary.fees_covered += parseInt(donation.covered_fee);
        summary.total_amounts += parseInt(donation.covered_fee) > 0 ? donation.amount - parseInt(donation.covered_fee) : donation.amount;
      }

      summary.fees = summary.platform_fee + summary.stripe_fee;

      return summary;
    },
    prevTotal() {
      const duration = moment.duration(this.period.end.diff(this.period.start));

      const prevPeriod = {
        start: moment(this.startDate, 'MM/DD/YYYY').subtract(1 + parseInt(duration.asDays()), 'days'),
        end: moment(this.startDate, 'MM/DD/YYYY').subtract(1, 'days').set({
          'hour': 23,
          'minute': 59,
          'second': 59,
        }),
      };

      let prevTotal = 0;

      const startUnix = prevPeriod.start.unix();
      const endUnix = prevPeriod.end.unix();

      for (let donation of this.donations) {
        if (startUnix < donation.createdAtParsed && donation.createdAtParsed <= endUnix) {
          prevTotal += donation.amount;
        }
      }

      return prevTotal;
    },
    diffPercent() {
      if (this.prevTotal > 0 && (this.summary.rounds + this.summary.custom + this.summary.monthly) > 0) {
        let result = parseInt((this.summary.rounds + this.summary.custom + this.summary.monthly) / this.prevTotal *
          100 - 100);

        if (result > 1000) {
          result = 1000;
        }
        if (result < -1000) {
          result = -1000;
        }
        return result;
      }
      return 0;
    },
    firstDonationDate() {
      if (this.donations.length) {
        return moment(this.donations[this.donations.length - 1].created_at).format('MM/DD/YYYY')
      }

      return false;
    }
  },
  data() {
    return {
      startDate: ('start-date' in this.$route.query) ? moment(this.$route.query['start-date'], 'MM-DD-YYYY').format('MM/DD/YYYY') : moment().subtract(29, 'days').format('MM/DD/YYYY'),
      endDate: ('end-date' in this.$route.query) ? moment(this.$route.query['end-date'], 'MM-DD-YYYY').format('MM/DD/YYYY') : moment().format('MM/DD/YYYY'),
    };
  },

};
